import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initializeApp, isNativeApp } from './capacitor';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Initialize Capacitor for native apps
initializeApp();

// Register service worker for PWA functionality (only for web)
if (!isNativeApp) {
  serviceWorkerRegistration.register({
    onSuccess: () => {
      console.log('Nanda Diagnostics PWA: Content cached for offline use.');
    },
    onUpdate: () => {
      console.log('Nanda Diagnostics PWA: New content available. Please refresh.');
    }
  });
}
